"use client";

import { useEffect, useRef } from "react";

import { projectPageViewEvent } from "@/dataLayer/dataLayer";

interface ProjectPageTrackerProps {
  projectName?: string;
  propertyType?: string;
}

export default function ProjectPageTracker({ projectName, propertyType }: ProjectPageTrackerProps) {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current && projectName && propertyType) {
      projectPageViewEvent(projectName, propertyType ?? "");
      hasTracked.current = true;
    }

    if (!hasTracked.current && projectName && propertyType === undefined) {
      projectPageViewEvent(projectName, propertyType ?? "");
      hasTracked.current = true;
    }
  }, [projectName, propertyType]);

  return null;
}
